import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

const theBestTechPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#2563EB]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#2563EB]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#2563EB] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: 'shadow-xl',
  HOMEPAGE_HEADER_BG: 'bg-[#F9FAFB]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#2563EB]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#FB923C] hover:border-[#FB923C] hover:bg-[#FB923C] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#FB923C]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#A7F3D0]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#2563EB]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#2563EB]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#A7F3D0]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#2563EB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#2563EB] text-[#2563EB] [&>svg>path]:stroke-[#2563EB] [&>svg>g>path]:stroke-[#2563EB] [&>svg>path]:fill-[#2563EB] [&>svg>g>path]:fill-[#2563EB]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#2563EB]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#2563EB]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#F9FAFB]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#A7F3D0]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#F9FAFB]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#2563EB] [&>.explore-icon-fill]:!fill-[#F9FAFB] [&>g>.explore-icon-fill]:!fill-[#F9FAFB]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F9FAFB] [&>.vector-top>path]:fill-[#2563EB] [&>.vector-bottom>path]:fill-[#2563EB]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#A7F3D0]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#047857]',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#FBBF24]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#171717]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#A7F3D0]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#047857]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#A7F3D0]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-[#047857]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#A7F3D0]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-[#047857]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#A7F3D0]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#047857]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#BFDBFE]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#2C0065]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#2C0065]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#BFDBFE]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#1F2937]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#2563EB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#2563EB] text-[#2563EB] [&>svg>path]:stroke-[#2563EB] [&>svg>g>path]:stroke-[#2563EB] [&>svg>path]:fill-[#2563EB] [&>svg>g>path]:fill-[#2563EB]',
  LISTPAGE_BUTTON_LINK: 'text-[#2563EB]',
  LISTPAGE_ANCHOR_LINK: 'text-[#2563EB]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#2563EB]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#2563EB]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#2563EB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#2563EB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#2563EB] text-[#2563EB]  [&>svg>path]:stroke-[#2563EB] [&>svg>g>path]:stroke-[#2563EB] [&>svg>path]:fill-[#2563EB] [&>svg>g>path]:fill-[#2563EB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#2563EB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#2563EB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#2563EB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#2563EB]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'border-neutral-100',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border-none',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#2563EB]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#BFDBFE] [&>.vector-top>path]:fill-[#2563EB] [&>.vector-bottom>path]:fill-[#2563EB]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100 tablet:bg-[#E2E8F0]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#BFDBFE] [&>circle]:stroke-[#BFDBFE] [&>path]:fill-[#2563EB]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#BFDBFE]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#2563EB]',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-black data-[focus]:bg-[#BFDBFE]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-[#2563EB] bg-[#BFDBFE]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#2563EB]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',

  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}

export default theBestTechPicksStylesUS
